import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import TermOfServiceContainer from '~/features/term-of-services'
import en_request_demo from '../../public/locales/en/request-demo.json'
import jp_request_demo from '../../public/locales/ja/request-demo.json'

const TermOfServicePage = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadMetaTags
        title={t('meta:term_of_services:meta_title')}
        description={t('meta:term_of_services:meta_description')}
      />
      <TermOfServiceContainer />
    </>
  )
}

export default withTranslateProvider(TermOfServicePage, {
  en: { request_demo: en_request_demo },
  ja: { request_demo: jp_request_demo }
})
